<template>
  <Header></Header>
  <div class="main-height player-style">
    <div class="col-md-offset-3 col-sm-7 col-sm-offset-3" style='margin:0px auto;'>
      <div v-if="dynamicData && event">
      <div class="account-heading"><strong>Playing now:</strong> {{ event.firstMatcher + " vs " + event.secondMatcher }}</div>
      <video ref="videoPlayer" id="VideoJS-player" class="video-js vjs-default-skin" controls></video>
      <VideoBufferMonitor v-if="nativeVideoElement" :video-element="nativeVideoElement"
                          :trial-today-time="userPlan?.trial ? Number(userProfile?.trialTodayTime) : undefined" @monitorBuffering="handleBuffering" />
      <div v-if="alternativeChannelAvailable" class="text-center">
        <br>
        <p class="change-source-text">Having problems with the stream?</p>
        <button @click="changeSource" :disabled="disableChangeSource" class="btn change-source-btn">Alternative source</button>
      </div>
    </div>
    </div>
  </div>
  <div class=""><Footer></Footer></div>
</template>

<script>
import {defineComponent, nextTick, toRaw, ref} from 'vue'
import Header from "@/components/Header.vue";
import Footer from "@/components/Footer.vue";
import VueSimpleAlert from 'vue3-simple-alert';
import UsersService from "@/services/users-service";
import AuthService from "@/services/auth-service";
import SessionService from "@/services/session-service";
import UserAgentParser from '@/utils/user-agent-parser';
import ChromecastService from '@/services/chromecast-service';
import videojsqualityselector from 'videojs-hls-quality-selector';
import videojslandscapefullscreen from 'videojs-landscape-fullscreen';
import { event } from "vue-gtag";
import LeagueService from "@/services/league-service";
import videojs from 'video.js';
import 'video.js/dist/video-js.css';
import {BufferEventRequest} from "@/model/models";
import VideoBufferMonitor from "@/components/VideoBufferMonitor.vue";
import MonitoringService from "@/services/monitoring-service";

export default defineComponent({
  name: 'VideoPlayer',
  props: {
    options: {
      type: Object,
      default() {
        return {
          autoplay: true,
          controls: true,
          width: 800,
          height: 600,
          fluid: true,
          muted: false,
          volume: 0.8,
          loop: false,
          crossorigin: 'anonymous',
          responsive: true,
          preferFullWindow: true,
          playsinline: false,
          disablePictureInPicture: false,
          html5: {
            vhs: {
              maxPlaylistRetries: 3,
              enableLowInitialPlaylist: videojs.browser.IS_ANY_SAFARI || videojs.browser.IS_IOS || videojs.browser.IS_IPAD,
              limitRenditionByPlayerDimensions: false,
              overrideNative: !(videojs.browser.IS_ANY_SAFARI || videojs.browser.IS_IOS || videojs.browser.IS_IPAD),
              useNetworkInformationApi: true,
              smoothQualityChange: true,
            },
            nativeAudioTracks: false,
            nativeVideoTracks: false
          },
        };
      }
    }
  },
  components: {
    Header,
    VideoBufferMonitor,
    Footer
  },
  setup() {
    const playerPage = () => {
      event('player', { method: 'Google' })
    }
    return {
      playerPage
    }
  },

  data() {
    return {
      userProfile: null,
      userPlan: null,
      interval: null,
      streamUrl: "",
      baseStreamUrl: "",
      startupCheckScheduled: false,
      hasEverPlayed: false,
      startupTimeoutId: null,
      player: null,
      userAgent: "",
      deviceType: null,
      deviceOs: null,
      appVersion: "",
      event: null,
      channel: null,
      dynamicData: [],
      chromecastService: null,
      alternativeChannelAvailable: false,
      playingChannels: [],
      disableChangeSource: true,
      selectedChannel: null,
      nativeVideoElement: null
    }
  },
  methods: {
    channelDisconnects() {
      VueSimpleAlert.alert("Channel is not available. Try again later.", "Player error")
      this.$router.push('/events')
    },
    goEvents() {
      this.$router.push('/events')
    },
    handleMounted: function (payload) {
      //console.log('----handleMounted', payload)
      // this.player = payload.player
    },
    handlePlayerReady(player) {
      this.initializeChromecast();
      if (this.userProfile.videoQuality === undefined && !videojs.browser.IS_ANY_SAFARI && !videojs.browser.IS_IOS && !videojs.browser.IS_IPAD) {
        this.player.hlsQualitySelector({
          displayCurrentQuality: true,
          placementIndex: 2,
        });
      }
      this.player.landscapeFullscreen({
        fullscreen: {
          enterOnRotate: true,
          exitOnRotate: true,
          alwaysInLandscapeMode: true,
          iOS: false
        }
      })
      this.player.on('waiting', () => {
        if (this.hasEverPlayed) return;
        if (this.startupCheckScheduled) return;

        this.startupCheckScheduled = true;
        this.startupTimeoutId = setTimeout(() => {
          this.startupTimeoutId = null;
          if (!this.hasEverPlayed) {
            this.disableChangeSource = false;
            this.handleBuffering()
          } }, 5000);
      });
      this.player.on('playing', () => {
        this.hasEverPlayed = true;
        if (this.startupTimeoutId) {
          clearTimeout(this.startupTimeoutId);
          this.startupTimeoutId = null;
        }
        this.disableChangeSource = false;
      });
      this.player.on('pause', () => {
        this.leavePictureInPicture()
        const castStarted = JSON.parse(sessionStorage.getItem('chromecastStarted'));
        if (castStarted) {
          this.disableChangeSource = true;
        }
      });

    },
    handleError(event) {
      this.channelDisconnects()
    },
    getUserLatest() {
      UsersService.getUserLatest().then((newUserLatest) => {
        if (newUserLatest) {
          this.compareUserLatest(newUserLatest)
        }
      })
    },
    compareUserLatest(newUserLatest) {
      if (localStorage.getItem('userLatest') && localStorage.getItem('userLatest') !== JSON.stringify(newUserLatest)) {
        const oldUserLatest = JSON.parse(localStorage.getItem('userLatest'))
        // compare user latest
        if (oldUserLatest.loginId !== newUserLatest.loginId) {
          AuthService.signOut().then(() => {
            localStorage.setItem('sessionExpired', "true")
            this.$router.push('/signin')
          })
        }
        if (oldUserLatest.userProfile !== newUserLatest.userProfile
            || oldUserLatest.userPlans !== newUserLatest.userPlans) {
          // update user profile
          UsersService.getUserProfile().then(() => {
            if (localStorage.getItem('userProfile')) this.userProfile = JSON.parse(localStorage.getItem('userProfile'))
            if (localStorage.getItem('userPlan')) this.userPlan = JSON.parse(localStorage.getItem('userPlan'))
            if (this.userPlan.trial && (this.userProfile.trialOverallTime <= 0 || this.userProfile.trialTodayTime <= 0)) {
              this.$router.push('/plans')
            }
            if (!this.userProfile.planActive && !this.userProfile.planStatus) this.$router.push('/signin')
            if (this.userProfile) this.planEndDate = new Date(this.userProfile.planEndDate).toLocaleDateString()
          })
        }
        if (oldUserLatest.payments !== newUserLatest.payments) {
          // update user payments
        }
        if (oldUserLatest.statics !== newUserLatest.statics) {
          UsersService.getUserStaticData()
        }
        if (oldUserLatest.channels !== newUserLatest.channels) {
          // update leagues
          LeagueService.getLeagueList().then(() => {
            this.setSelectedEvent()
          })
        }
      }
      this.error = newUserLatest.errorText
      localStorage.setItem('userLatest', JSON.stringify(newUserLatest))
    },
    doAccount() {
      this.$router.push('/account')
    },
    selectNextPlayingChannel() {
      if (!this.playingChannels || this.playingChannels.length === 0) return;

      const currentIndex = this.playingChannels.findIndex(channel => channel.playing);

      this.playingChannels[currentIndex].playing = false;
      let nextIndex;
      if (currentIndex >= 0 && currentIndex < this.playingChannels.length - 1) {
        nextIndex = currentIndex + 1;
      } else {
        // Either no channel is currently playing, or we’re at the end — go back to first
        nextIndex = 0;
      }

      this.playingChannels[nextIndex].playing = true;
    },
    changeSource() {
      if (this.chromecastService)  this.chromecastService.stopCasting();
      this.leavePictureInPicture();
      this.disableChangeSource = true;
      if (this.dynamicData.vidictId) {
        const session = UserAgentParser.createSession(this.dynamicData.vidictId, this.deviceOs, this.deviceType, this.appVersion, this.userAgent);
        SessionService.updateAndDisconnectSession(session)
      }
      this.selectNextPlayingChannel()
      this.resetInitialCheck()
      UsersService.getDynamicData().then((data) => {
        this.dynamicData = data
        this.setupPlayerUrl();
        const player = toRaw(this.player);
        player.pause();
        player.reset();
        player.src({ src: this.streamUrl, type: 'application/x-mpegURL' });
        player.load();
        this.nativeVideoElement = this.player.el().querySelector('video');
        player.play();
      })
    },
    resetInitialCheck(){
      this.startupCheckScheduled = false;
      this.hasEverPlayed = false;
      if (this.startupTimeoutId) {
        clearTimeout(this.startupTimeoutId);
        this.startupTimeoutId = null;
      }
    },
    setupPlayerUrl() {
      this.selectedChannel = this.playingChannels.find(ch => ch.playing === true);
      if (this.selectedChannel) {
        if (this.selectedChannel.edgePort === "" || this.selectedChannel.edgePort === undefined) {
          this.baseStreamUrl = "https://" + this.dynamicData.edgeAddress + "/"
        } else {
          this.baseStreamUrl = "https://" + this.dynamicData.edgeAddress + ":" + this.selectedChannel.edgePort + "/"
        }
        this.streamUrl = this.selectedChannel.appName + "/" + this.checkUndefined(this.selectedChannel.hlsPrefix) + this.selectedChannel.channelName
            + this.checkUndefined(this.selectedChannel.hlsSufix)
            + this.checkUndefined(this.dynamicData.videoQuality)
            + "/playlist.m3u8?id=" + this.selectedChannel.channelId + "&pk=" + this.dynamicData.pk + "&userId="
            + this.userProfile.userId + "&vidictid=" + this.dynamicData.vidictId
        const skValue = localStorage.getItem('sk');
        if (skValue !== null) {
          this.streamUrl += "&sk=" + skValue
        }
        this.streamUrl = this.baseStreamUrl + this.streamUrl;
      } else this.goEvents()
    },
    setupDeviceInfo() {
      this.userAgent = navigator.userAgent;
      this.deviceType = UserAgentParser.extractDeviceType(this.userAgent);
      this.deviceOs = UserAgentParser.extractDeviceOs(this.userAgent);
      this.appVersion = UserAgentParser.getAppVersion(this.userAgent, this.deviceType);
    },
    leavePictureInPicture() {
      if (document.pictureInPictureElement) {
        document.exitPictureInPicture().catch((err) => {
          //console.warn("Error exiting Picture-in-Picture:", err);
        });
      }
    },
    leavePage: function (reload) {
      try {
        if (this.startupTimeoutId) {
          clearTimeout(this.startupTimeoutId);
          this.startupTimeoutId = null;
        }
        this.startupCheckScheduled = false;
        if (this.chromecastService)  this.chromecastService.dispose();
        this.leavePictureInPicture();
        if (this.player) {
          this.player.dispose();
          this.player = null;
        }
        clearInterval(this.interval);
        if (this.dynamicData && this.dynamicData.vidictId) {
          const session = UserAgentParser.createSession(this.dynamicData.vidictId, this.deviceOs, this.deviceType, this.appVersion, this.userAgent);
          SessionService.updateAndDisconnectSession(session).finally(() => {
            if (reload) location.reload();
          });
        }
      } catch (error) {
        //console.error("Error during source change:", error);
        this.$router.push('/events')
      }
    },
    checkUndefined(inputString) {
      if (typeof inputString === 'undefined' || inputString === '' || inputString === null) {
        return '';
      } else {
        return inputString;
      }
    },

    initializeChromecast() {
      this.chromecastService = new ChromecastService(this.player, this.streamUrl);
      this.chromecastService.initialize()
    },
    initializePlayer() {
      this.player = videojs(this.$refs.videoPlayer,{
        ...this.options,
        sources: [{
          src: this.streamUrl,
          type: 'application/x-mpegURL'
        }]
      }, (player) => {
        this.nativeVideoElement = this.player.el().querySelector('video');
        this.handlePlayerReady({player});
        this.handleMounted(player);
      });
      this.player.on('error', this.handleError);
      this.getUserLatest();
      this.interval = setInterval(() => {
        this.getUserLatest();
      }, 30000);
    },
    setSelectedEvent() {
      if (sessionStorage.getItem('selectedEventId') && localStorage.getItem('leagueList')) {
        const selectedEventId = Number(sessionStorage.getItem('selectedEventId'));
        const leaguesList = JSON.parse(localStorage.getItem('leagueList'));
        leaguesList.forEach(league => {
          if (league.application === "procricket") {
            this.event = league.events?.find(e => e.eventId === selectedEventId);
            this.setPlayingChannels()
          }
        })
      }
    },
    setPlayingChannels() {
      // Populate playingChannels
      const existingPlayingMap = new Map(
          this.playingChannels?.map(ch => [ch.channelId, ch.playing]) || []
      );
      this.playingChannels = this.event.channels
          .filter(channel => channel.active && channel.status)
          .map(channel => ({...channel, playing: existingPlayingMap.get(channel.channelId) ?? false}))
          .sort((a, b) => a.orderNumber - b.orderNumber);

      // No channel available
      //if (this.playingChannels.length === 0) this.channelDisconnects()
      // Set alternative channel flag
      this.alternativeChannelAvailable = this.playingChannels.length > 1;

      // If no channel is playing, set the first one
      if (!this.playingChannels.some(channel => channel.playing) && this.playingChannels.length > 0) {
        this.playingChannels[0].playing = true;
        // const wasPlayingDifferentChannel = Array.from(existingPlayingMap.entries())
        //     .some(([id, playing]) => playing === true && id !== this.playingChannels[0].channelId);
        // if (wasPlayingDifferentChannel) {
        //   this.changeSource();
        // }
      }
    },
    handleBuffering() {
      try {
        if (!this.selectedChannel || !this.userProfile || !this.dynamicData) return;
        if (!this.selectedChannel.appName) return; //Check MA-491 for reasoning
        const eventData = new BufferEventRequest(this.userProfile.userId, this.dynamicData.edgeAddress, "procricket",
            this.selectedChannel.appName, this.selectedChannel.channelName, this.selectedChannel.channelId, 'BUFFERING')
        MonitoringService.sendMonitoringBuffer(eventData)
      } catch (error) {
          //console.error(error);
      }
    },
    handlePageRefresh() {
      if (this.chromecastService)  this.chromecastService.dispose();
    },
  },

  mounted() {
    //this.initializePlayer();
    // Properly setup onRequest hook for updating OTP
    if (videojs.Vhs && videojs.Vhs.xhr && typeof videojs.Vhs.xhr.onRequest === 'function') {
      videojs.Vhs.xhr.onRequest((options) => {
        const sk = localStorage.getItem('sk');
        if (options.uri && sk) {
          const url = new URL(options.uri, window.location.origin);
          url.searchParams.set('sk', sk);
          options.uri = url.toString();
        }
        return options;
      });
    }
    window.addEventListener('beforeunload', this.handlePageRefresh);
  },

  beforeMount() {
    clearInterval(this.interval);
    if (localStorage.getItem('userProfile')) this.userProfile = JSON.parse(localStorage.getItem('userProfile'))
    if (localStorage.getItem('userPlan')) this.userPlan = JSON.parse(localStorage.getItem('userPlan'))
    if (!sessionStorage.getItem('selectedEventId') || !localStorage.getItem('leagueList')) {
      this.goEvents()
    } else {
      this.setSelectedEvent()
      const dynamicDataFromStorage = sessionStorage.getItem('dynamicData');
      if (dynamicDataFromStorage) {
        this.dynamicData = JSON.parse(dynamicDataFromStorage);
        this.setupPlayerUrl();
        nextTick(() => {
          this.initializePlayer();
        });
      } else {
        UsersService.getDynamicData().then((data) => {
          this.dynamicData = data;
          this.setupPlayerUrl();
          this.initializePlayer();
        }).catch(() => {
          this.channelDisconnects();
        });
      }
      if (localStorage.getItem('coupon')) {
        localStorage.setItem('coupon', null)
      }
      this.setupDeviceInfo();
    }
  },

  beforeUnmount() {
    window.removeEventListener('beforeunload', this.handlePageRefresh);
    this.leavePage()
  }
})
</script>

<style scoped>
@import '../assets/style.css';

.player-style {
  margin-top: 3%;
  margin-bottom: 3%;
  display: flex;
  justify-content: center;
  align-items: center;
  text-align: center;
}
</style>
